/* eslint-disable camelcase */
import React, { FC, useCallback, useMemo } from "react"
import { Appearance } from "react-native"
import { CompositeScreenProps } from "@react-navigation/native"
import { CycleCloseMultipleForm as ModelForm, ModelCreateMultipleScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { Cycle } from "../../../../database"

export const CycleCloseMultipleScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CycleCloseMultipleScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmStore, farmId },
    cycleStore: modelStore
  } = useStores();

  const initialValues = useMemo<any>(() => {
    return {
      farm_id: farmId
    }
  }, [farmId])

  const onSuccess = useCallback((success: boolean) => {
    if (modelStore.needRefresh) {
      if (success) {
        farmStore.initWithLastBatch(() => {
          modelStore.set('needRefresh', false);
          modelStore.set('pushIdQueue', {})
        });
      } else {
        modelStore.set('needRefresh', false);
        modelStore.set('pushIdQueue', {})
      }
    }
    return success;
  }, [farmStore, modelStore])

  return (
    <ModelCreateMultipleScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      initialValues={initialValues}
      modelStore={modelStore}
      Model={Cycle}
      onSuccess={onSuccess}
      saveTx="cycleCloseScreen.title"
    />
  )
})
